<template>
  <div class="mask"></div>
</template>

<script>
export default {
  props: {
    borderRadius: {
      type: String,
      default: '0%'
    }
  }
};
</script>

<style lang="scss" scoped>
.mask {
  height: 100%;
  width: 100%;
  background-color: gray;
}
</style>
